import { getScalablePixel } from 'common/utils';

export const SAFE_AREA_VIEW_PADDING = getScalablePixel(166);
export const VERTICAL_SAFE_AREA_VIEW_PADDING = getScalablePixel(76);
export const DETAILED_INFO_SAFE_AREA_PADDING = getScalablePixel(132);

export const LOADING_WAITS_FOR_PLAYER = false;
